import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callEditDiscounts, callGetDiscountsById } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import { toast } from "react-toastify";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const Index = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [discounts, setDiscounts] = useState({
		name: '', insuranceType: '', type: '', priority: 1, carriredCode: '', carriredName: '', id: null, typeName: '', insuranceTypeName: '',
		validateFrom: '', validateTo: '', valueDirection: '', valueType: '', roles: '', valueTypeName: '', direction: '', roleId: ''
	});
	const [validateFrom, setValidateFrom] = useState(null);
	const [validateTo, setValidateTo] = useState(null);
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				setDiscounts((prev) => ({
					...prev, id
				}));
				intialData(id)
			}
		}
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setDiscounts((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}
	}, []);

	const intialData = async (id) => {
		const res = await dispatch(callGetDiscountsById({ id }))
		if (res?.payload?.responseCode === "00000") {
			let data = res?.payload?.data
			setDiscounts((prev) => ({
				...prev,
				id,
				name: data?.name,
				type: data?.type,
				typeName: data?.type === 1 ? t("settings.discount.newRenew.new") : t("settings.discount.newRenew.renew"),
				valueDirection: data?.valueDirection,
				insuranceType: data?.insuranceType,
				insuranceTypeName: data?.insuranceTypeName,
				valueType: data?.valueType,
				valueTypeName: data?.valueType === 1 ? t("settings.discount.unit.number") : "%",
				roles: data?.roleName,
				direction: data?.direction,
				priority: data?.priorty,
				roleId: data?.roleId,
			}));

			setValidateFrom(data?.validateFrom != null ? moment(data?.validateFrom).format("YYYY-MM-DD") : null)
			setValidateTo(data?.validateTo != null ? moment(data?.validateFrom).format("YYYY-MM-DD") : null)
		}
	}

	const handleChange = (e) => {
		const { name, value } = e.target;
		setDiscounts({
			...discounts,
			[name]: value,
		});
	};

	const handleSave = async (e) => {
		e.preventDefault()
		try {
			Swal.fire({
				name: t("nameSave"),
				text: t("confirmSave"),
				icon: "warning",
				reverseButtons: true,
				showCancelButton: true,
				confirmButtonColor: colors.confirmMessage,
				cancelButtonColor: colors.cancel,
				confirmButtonText: t('confirm'),
				cancelButtonText: t('cancel')
			}).then(async (result) => {
				if (result.isConfirmed) {
					try {

						let req = {
							id: discounts.id,
							name: discounts.name,
							type: discounts.type,
							roleId: discounts.roleId,
							insuranceType: discounts.insuranceType,
							valueDirection: discounts.valueDirection,
							valueType: discounts.valueType,
							direction: discounts.direction,
							priorty: discounts.priority,
							modifiedCode: discounts.carriredCode,
							modifiedName: discounts.carriredName,
							validateFrom: validateFrom,
							validateTo: validateTo
						}
						let res = await dispatch(callEditDiscounts(req));
						if (res?.payload?.responseCode === "00000") {
							Swal.fire({
								icon: "success",
								title: t("success.add"),
								confirmButtonColor: colors.confirmMessage,
								confirmButtonText: t('close'),
							}).then(function () {
								notifyListRefresh();
								navigate(-1);
							});
						} 
					} catch (error) {
						Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
					}
				}
			});
		} catch (error) {
			console.error("error: ", error)
		}
	}
	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{t("settings.discount.edit")}</h4>
						</div>

						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.name')} </label>
												<input
													type="text"
													name="name"
													className="form-control-uld"
													placeholder={t('settings.discount.name')}
													onChange={handleChange}
													value={discounts.name}
													autoComplete="off"
													readOnly />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.insuranceType')} </label>
												<input
													type="text"
													name="insuranceTypeName"
													className="form-control-uld"
													onChange={handleChange}
													value={discounts.insuranceTypeName}
													autoComplete="off"
													readOnly />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.type')}</label>
												<input
													type="text"
													name="typeName"
													className="form-control-uld"
													onChange={handleChange}
													value={discounts.typeName}
													autoComplete="off"
													readOnly />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.validateFrom')}</label>
												{/* <input
													type="date"
													name="validateFrom"
													className="form-control-uld"
													placeholder={t('settings.discount.validateFrom')}
													onChange={handleChange}
													value={discounts.validateFrom}
													autoComplete="off"
												/> */}

												<DatePicker
													name="validateFrom"
													selected={validateFrom}
													onChange={date => setValidateFrom(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('settings.discount.validateFrom')}
													className="form-control-uld"
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.validateTo')}</label>
												{/* <input
													type="date"
													name="validateTo"
													className="form-control-uld"
													placeholder={t('settings.discount.validateTo')}
													onChange={handleChange}
													value={discounts.validateTo}
													autoComplete="off"
												/> */}

												<DatePicker
													name="validateTo"
													selected={validateTo}
													onChange={date => setValidateTo(moment(date).format('YYYY-MM-DD'))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('settings.discount.validateTo')}
													className="form-control-uld"
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.valueDirection')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="valueDirection"
													className="form-control-uld"
													placeholder={t('settings.discount.valueDirection')}
													onChange={handleChange}
													value={discounts.valueDirection}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.valueType')} </label>
												<input
													type="text"
													name="valueTypeName"
													className="form-control-uld"
													onChange={handleChange}
													value={discounts.valueTypeName}
													autoComplete="off"
													readOnly />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('settings.discount.roles')}</label>
												<input
													type="text"
													name="roles"
													className="form-control-uld"
													onChange={handleChange}
													value={discounts.roles}
													autoComplete="off"
													readOnly />
											</div>

											<div className="col-12 d-flex justify-content-center">
												<div className="m-3">
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
